var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('div',{class:_vm.$style.hint},[_c('Hint',[_c('p',{staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.text))])])],1),_c('img',{class:_vm.$style.char,attrs:{"src":_vm.char}})])}
var staticRenderFns = []

export { render, staticRenderFns }